'use strict';
//添加全局方法资源
const api = require('./ApiFactory.js');
// const request=require('./config.js');
export default {
    install: function(Vue, options) {
        //判断本地是否缓存了登陆信息，否有则判断是否token过期，过期跳登陆页，没有过期，则跳主页
        Vue.prototype.isUserLogged = function() {
                var userInfo = this.dao.get('userInfo') || '';

                if (userInfo && userInfo.AccessToken) {
                    this.setHttpHeaders(userInfo.AccessToken);

                } else {
                    this.$router.push({ path: '/login' });
                }
            }
            //定义get请求方法getRequest
        Vue.prototype.getRequest = function(config) {
            var config = config;
            loadingData(true);

            var http = this.$http.get(config.url, { params: config.params }, { emulateJSON: true }).then(response => {
                loadingData(false);
                if (response.status == 200) {
                    return response.body;
                }
            }, response => {
                loadingData(false);
                // error callback
                if (response.status == 401) {
                    //如果该请求是不需要验证的，则跳过。
                    if (config.isAnonymous) {
                        return;
                    }

                    this.dao.set('userInfo', '')
                    this.$router.push({ path: '/login' });
                    return;
                }
                if (config.url.indexOf('Favorite/Exists') > -1) {
                    return;
                }
                var errorMsg = response.data.Message ? response.data.Message : response.data.error_description;
                this.error({ title: '提示', content: errorMsg ? errorMsg : '网络出错，请重试' });
            });
            return http;
        }

        //定义put请求方法getRequest
        Vue.prototype.putRequest = function(config) {
            //缓存当前路由地址，当用户未受权的时候获取新的code并回到当前页
            loadingData(true);

            var http = this.$http.put(config.url, config.params, { emulateJSON: true }).then(response => {
                loadingData(false);
                if (response.status == 200) {
                    return response.body;
                }
            }, response => {
                loadingData(false);
                // error callback
                if (response.status == 401) {

                    this.dao.set('userInfo', '')
                    this.$router.push({ path: '/login' });
                    return;
                }
                var errorMsg = response.data.Message ? response.data.Message : response.data.error_description;
                this.error({ title: '提示', content: errorMsg ? errorMsg : '网络出错，请重试' });
            });
            return http;
        }

        //定义PATCH 请求方法getRequest
        Vue.prototype.patchRequest = function(config) {
                //缓存当前路由地址，当用户未受权的时候获取新的code并回到当前页
                loadingData(true);

                var http = this.$http.patch(config.url, config.params, { emulateJSON: true }).then(response => {
                    loadingData(false);
                    if (response.status == 200) {
                        return response.body;
                    }
                }, response => {
                    loadingData(false);
                    // error callback
                    if (response.status == 401) {

                        this.dao.set('userInfo', '')
                        this.$router.push({ path: '/login' });
                        return;
                    }
                    var errorMsg = response.data.Message ? response.data.Message : response.data.error_description;
                    this.error({ title: '提示', content: errorMsg ? errorMsg : '网络出错，请重试' });
                });
                return http;
            }
            //定义get请求方法getRequest
        Vue.prototype.jsonpRequest = function(config) {
            var config = config;
            loadingData(true);

            var http = this.$http.jsonp(config.url, { timeout: 3000 }).then(response => {
                loadingData(false);
                if (response.status == 200) {
                    return response.body;
                }
            }, response => {


                loadingData(false);
                return {}
            });
            return http;
        }


        //定义post请求方法
        Vue.prototype.postRequest = function(config) {
            //缓存当前路由地址，当用户未受权的时候获取新的code并回到当前页
            loadingData(true);

            var http = this.$http.post(config.url, config.params, { emulateJSON: true }).then(response => {
                loadingData(false);
                if (response.status == 200) {
                    return response.body;
                }
            }, response => {
                loadingData(false);
                // error callback
                if (response.status == 401) {

                    this.dao.set('userInfo', '')
                    this.$router.push({ path: '/login' });
                    return;
                }
                var errorMsg = response.data.Message ? response.data.Message : response.data.error_description;
                this.error({ title: '提示', content: errorMsg ? errorMsg : '网络出错，请重试' });
            });
            return http;
        }

        //返回首页

        Vue.prototype.toHome = function(e) {
                this.$router.push({ path: '/' });

            }
            //判断是否需要微信登录
        Vue.prototype.isWXLoginNeed = function(status) {
                if (localStorage && localStorage.cnToken) {
                    var cnToken = JSON.parse(localStorage.cnToken);

                    if (cnToken && cnToken.access_token && (new Date(cnToken[".expires"]) >= new Date())) {
                        return false;
                    }
                }
                return true;
            }
            //判断是否需要登录
        Vue.prototype.isUserLoginNeeded = function(url) {

                if (!localStorage.cnToken) {
                    localStorage.lastPageUrl = url;
                    this.$router.push('/Login');
                }

            }
            //日期期格式化周几
        Vue.prototype.dateWeek = function(date) {
                var nowDate = new Date();
                var days = getDays(nowDate, date);

                var mydate = new Date(date);

                var myday = mydate.getDay() //注:0-6对应为星期日到星期六
                var xingqi;
                switch (myday) {
                    case 0:
                        xingqi = "周日";
                        break;
                    case 1:
                        xingqi = "周一";
                        break;
                    case 2:
                        xingqi = "周二";
                        break;
                    case 3:
                        xingqi = "周三";
                        break;
                    case 4:
                        xingqi = "周四";
                        break;
                    case 5:
                        xingqi = "周五";
                        break;
                    case 6:
                        xingqi = "周六";
                        break;
                    default:
                        xingqi = ""
                }

                if (days == 0) {
                    return '今天';
                } else if (days == 1) {
                    return '明天';
                } else if (days == 2) {
                    return '后天';
                } else {
                    return xingqi;
                }
            }
            //日期期格式化为 00.00
        Vue.prototype.dateMMDD = function(date) {
            if (!date) return '';
            var da = new Date(date);
            var month = da.getMonth() + 1

            if (month < 10) { month = '0' + month };
            var date = da.getDate();
            if (date < 10) { date = '0' + date };
            return month + '.' + date;

        }

        //历史记录
        Vue.prototype.setHistory = function(hotel) {
            var list = this.dao.get('hotelHistory') || [];
            var index = isHotelExist(list, hotel);
            // console.log(index);
            hotel['date'] = new Date();
            if (index === '') {

                list.unshift(hotel);
            } else {
                list.splice(index, 1);
                list.unshift(hotel);
            }
            // console.log(list);
            this.dao.set('hotelHistory', list)

        }

        //日期期格式化为 0000-00 
        Vue.prototype.getMonths = function(value) {
            var myDate = new Date();
            myDate.setMonth(myDate.getMonth() + value, 1);
            var year = myDate.getFullYear();
            var month = myDate.getMonth() + 1;
            return year + '-' + (month < 10 ? ('0' + month) : month)
        }



        //建立全局部方法，登陆成功后，保存token并设置headers
        Vue.prototype.setHttpHeaders = function(token) {
                Vue.http.headers.common['Authorization'] = "Bearer " + token;
            }
            //建立全局部方法url跳转
        Vue.prototype.routetokPage = function(url) {

                this.$router.push({ path: url });


            }
            //建立全局校验手机号码的方法
        Vue.prototype.checkMobile = function(num) {

                if (!num) {
                    this.error({ title: '提示', content: '请输入手机号码' });
                    return false;
                }
                // if(!((/^1[3-9][0-9]\d{4,8}$/.test(num))||(/^([6|9])\d{7}$/.test(num))||(/^([6|9])\d{7}$/.test(num)))) {
                if (!(/^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[6]([8|6])\d{5}$/.test(num))) {
                    this.error({ title: '提示', content: '请输入正确的手机号码' });
                    return false;
                }
                return true;
            }
            /**
             * @SFZ 1 身份证 18位
             * @GAZ 2 港澳证 5位-21位
             * @HZ 4 护照 5位-21位
             * @JRZ 8 军人证 军字第2001988号, 士字第P011816X号
             * @XSZ 16 学生证 5位-21位
             * @TWZ 32 台湾通行证 8位-10位
             */
        Vue.prototype.paperType = function(type, num) {
            let regList = [
                { reg: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, id: '1', name: 'SFZ' },
                { reg: /^[a-zA-Z0-9]{5,21}$/, id: '2', name: 'GAZ' },
                { reg: /^[a-zA-Z0-9]{5,21}$/, id: '4', name: 'HZ' },
                { reg: /[\u4e00-\u9fa5](字第){1}(\d{4,8})(号?)$/, id: '8', name: 'JRZ' },
                { reg: /^[a-zA-Z0-9]{5,21}$/, id: '16', name: 'XSZ' },
                { reg: /^[a-zA-Z0-9]{8,10}$/, id: '32', name: 'TWZ' },
            ]

            if (type && num) {
                regList.forEach(item => {
                    if (item.id == type) {
                        if (!item.reg.test(num)) {
                            this.error({ title: '提示', content: '请输入正确的证件号码' });
                            return false;
                        }
                    }
                })
            } else {
                this.error({ title: '提示', content: '请输入住客证件号码！' });
                return false;
            }
            return true
        }

        // 计算日期差
        Vue.prototype.getDays = function(s1, s2) {
                s1 = new Date(s1.replace(/-/g, "/"));
                s2 = new Date(s2.replace(/-/g, "/"));

                var days = s2.getTime() - s1.getTime();
                var time = parseInt(days / (1000 * 60 * 60 * 24));
                return time > 0 ? time : 0;
            }
            //获取日期,count=1为明天，count=-1为前一天
        Vue.prototype.getDate = function(count) {
                var date = new Date();
                date.setDate(date.getDate() + count); //获取count天后的日期
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (day >= 0 && day <= 9) {
                    day = "0" + day;
                }

                var time = year + '-' + month + '-' + day;
                return time;
            }
            //日期期格式化为 0000-00-00
        Vue.prototype.dateToYMDline = function(date) {
            if (!date) return '';

            var da = new Date(date);
            var year = da.getFullYear();

            var month = da.getMonth() + 1;
            var day = da.getDate();

            if (month < 10) { month = '0' + month };
            if (day < 10) { day = '0' + day };
            return year + '-' + month + '-' + day;

        };
        //日期期格式化为 0000-00-00 00:00:00
        Vue.prototype.dateLongToYMDline = function(date) {
            if (!date) return '';
            date.replace('T', '');

            var da = new Date(date);
            var year = da.getFullYear();

            var month = da.getMonth() + 1;
            var day = da.getDate();

            if (month < 10) { month = '0' + month };
            if (day < 10) { day = '0' + day };

            var hour = da.getHours();
            if (hour < 10) {
                hour = '0' + hour;

            }
            var minutes = da.getMinutes();
            if (minutes < 10) {
                minutes = '0' + minutes;

            }
            var second = da.getSeconds();
            if (second < 10) {
                second = '0' + second;

            }
            return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + second;

        };
        Vue.prototype.setBodyScroll = function(val) {
            var body = document.getElementsByTagName('body')[0];
            if (val) {
                body.style.overflow = 'hidden';
                body.style.position = 'fixed';
            } else {
                body.style.overflow = 'auto';
                body.style.position = 'relative';
            }

        }

        //错误提示
        Vue.prototype.error = function(val) {
            var isCloseError = document.getElementById('closeError') ? true : false;

            if (isCloseError) return;
            var html = "  <div class='detail-modal'>\
                            <div class='modal'>\
                                <div class='modal-head'>" + val.title + "</div>\
                                <div class='modal-body'>" + val.content + "</div>\
                                <div class='modal-foot'>\
                                    <div class='btn-l' id='closeError' >确定</div>\
                                </div> \
                            </div>\
                        </div>"

            // var html="<div class='error-box'>\
            //             <h1>"+val.title+"</h1>\
            //             <h2>"+val.content+"</h2>\
            //             <div id='closeError' >确定</div>\
            //          </div>"
            var app = document.getElementById('app');

            var body = document.getElementsByTagName('body')[0];
            var temp = document.createElement('div');
            temp.id = 'errorBox';

            body.style.overflow = 'hidden';
            temp.innerHTML = html;
            app.appendChild(temp);

            var closeError = document.getElementById('closeError');
            closeError.onclick = function() {

                var target = document.getElementById('errorBox');
                body.style.overflow = 'auto';
                app.removeChild(target)
            }

        }


        Vue.prototype.openContact = function() {
            var isCloseError = document.getElementById('closeContact') ? true : false;

            if (isCloseError) return;
            var html = "  <div >\
                            <div class='lmy-mask-s'>\
                                <div class='lmy-modal'>\
                                    <div class='lmy-modal-head'>联系客服</div>\
                                    <div class='lmy-modal-menu' >\
                                        <a href='tel:0755-82338117'>\
                                        <div class='line-a' >\
                                            <i class='iconfont icon-f-10'></i>点击拨打 \
                                             0755-82338117\
                                        </div>\
                                        </a>\
                                        <div class='line'>\
                                             客服值班时间 \
                                            08:00-24:00\
                                        </div>\
                                    </div>\
                                    <div class='lmy-modal-foot'>\
                                        <div class='long-btn' id='closeContact' >取消</div>\
                                    </div>\
                                </div>\
                            </div>\
                        </div>\
                    "

            var app = document.getElementById('app');

            var body = document.getElementsByTagName('body')[0];
            var temp = document.createElement('div');
            temp.id = 'contactBox';

            body.style.overflow = 'hidden';
            temp.innerHTML = html;
            app.appendChild(temp);

            var closeContact = document.getElementById('closeContact');
            closeContact.onclick = function() {

                var target = document.getElementById('contactBox');
                body.style.overflow = 'auto';
                app.removeChild(target)
            }

        }

        Vue.prototype.toShare = function() {
            var shareBox = document.getElementById('shareBox') ? true : false;

            if (shareBox) return;

            var html = "<div class='share-info-box'>\
                        <i class='share-arrow'></i>\
                        <div class='share-text'><p>点击右上角按钮</p>\
                        <p>分享到朋友圈</p></div>\
                     </div>"
            var app = document.getElementById('app');

            var body = document.getElementsByTagName('body')[0];
            var temp = document.createElement('div');
            temp.id = 'shareBox';

            body.style.overflow = 'hidden';
            temp.innerHTML = html;
            app.appendChild(temp);
            var closeshareBox = document.getElementById('shareBox');
            closeshareBox.onclick = function() {

                var target = document.getElementById('shareBox');
                body.style.overflow = 'auto';
                app.removeChild(target)
            }


        }

        Vue.prototype.closeShareBox = function() {

            var target = document.getElementById('shareBox');
            body.style.overflow = 'auto';
            app.removeChild(target)



        }
        Vue.prototype.comfirmBox = function(val) {
                var isCloseError = document.getElementById('comfirmBox') ? true : false;

                if (isCloseError) return;

                var html = "<div class='error-box'>\
                        <h1>" + val.title + "</h1>\
                        <h2>" + val.content + "</h2>\
                     </div>"
                var app = document.getElementById('app');

                var body = document.getElementsByTagName('body')[0];
                var temp = document.createElement('div');
                temp.id = 'errorBox';

                body.style.overflow = 'hidden';
                temp.innerHTML = html;
                app.appendChild(temp);

            }
            //打开或者禁止页面滚动
        Vue.prototype.setBodyScrollable = function(status) {
            var body = document.getElementsByTagName('body')[0];
            if (status) {
                body.style.overflow = 'hidden';

            } else {
                body.style.overflow = 'auto';
            }

        }
        Vue.prototype.configShare = function() {
            var location = window.location.href;
            // var location='lmy.cnbooking.net';
            var data = {
                "url": location,
            }
            this.getRequest({
                url: this.Api.getShareParam,
                params: data
            }).then(res => {
                if (res) {

                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: this.Api.appId, // 必填，公众号的唯一标识
                        timestamp: res.TimeStamp, // 必填，生成签名的时间戳
                        nonceStr: res.Nonce, // 必填，生成签名的随机串
                        signature: res.Sign, // 必填，签名，见附录1
                        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'openLocation', 'getLocation'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    });
                }
            })
        }
        Vue.prototype.getUserLocation = function(callback) {

            wx.ready(() => {
                wx.getLocation({
                    type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                    success: function(res) {

                        var obj = {
                            latitude: res.latitude, // 纬度，浮点数，范围为90 ~ -90
                            longitude: res.longitude, // 经度，浮点数，范围为180 ~ -180。
                        }

                        callback(obj);
                    }
                });
            })
        }



        //清除所有收藏记录
        Vue.prototype.clearAllSearchRecord = function(id, that) {
            that.historySearchList = [];
            localStorage.historySearchList = '';

            this.error({ title: '提示', content: '清除成功' });
        }

        Vue.prototype.setConfigShare = function(option) {
            var option = option;
            var that = this;
            wx.ready(() => {
                //分享到朋友圈
                wx.onMenuShareTimeline({
                    title: option.Title, // 分享标题
                    link: option.Url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: option.Image, // 分享图标
                    success: function() {
                        // alert('success');
                        that.closeShareBox();
                    },
                    cancel: function() {
                        // 用户取消分享后执行的回调函数
                        // alert('cancel');
                        that.closeShareBox();
                    }
                });
                //分享给朋友
                wx.onMenuShareAppMessage({
                    title: option.Title, // 分享标题
                    desc: option.Desc, // 分享描述
                    link: option.Url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: option.Image, // 分享图标
                    type: '', // 分享类型,music、video或link，不填默认为link
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                    success: function() {
                        // 用户确认分享后执行的回调函数
                        // alert('success');
                        that.closeShareBox();
                    },
                    cancel: function() {
                        // 用户取消分享后执行的回调函数
                        // alert('success');
                        that.closeShareBox();
                    }
                });
                //分享到QQ
                wx.onMenuShareQQ({
                    title: option.Title, // 分享标题
                    desc: option.Desc, // 分享描述
                    link: option.Url, // 分享链接
                    imgUrl: option.Image, // 分享图标
                    success: function() {
                        // 用户确认分享后执行的回调函数
                        that.closeShareBox();
                    },
                    cancel: function() {
                        // 用户取消分享后执行的回调函数
                        that.closeShareBox();
                    }
                });
                //分享到腾讯微博
                wx.onMenuShareWeibo({
                    title: option.Title, // 分享标题
                    desc: option.Desc, // 分享描述
                    link: option.Url, // 分享链接
                    imgUrl: option.Image, // 分享图标
                    success: function() {
                        // 用户确认分享后执行的回调函数
                        that.closeShareBox();
                    },
                    cancel: function() {
                        // 用户取消分享后执行的回调函数
                        that.closeShareBox();
                    }
                });
                //分享到QQ空间
                wx.onMenuShareQZone({
                    title: option.Title, // 分享标题
                    desc: option.Desc, // 分享描述
                    link: option.Url, // 分享链接
                    imgUrl: option.Image, // 分享图标
                    success: function() {
                        // 用户确认分享后执行的回调函数
                        that.closeShareBox();
                    },
                    cancel: function() {
                        // 用户取消分享后执行的回调函数
                        that.closeShareBox();
                    }
                });
            })
        }
    }
};

function isHotelExist(list, hotel) {
    var index = '';
    for (var i = 0; i < list.length; i++) {
        if (list[i].ID == hotel.ID) {
            index = i;
            break;
        }
    }
    return index;

}
//开启和关闭缓冲层，status==true？开：关
function loadingData(status) {
    var html = "<div class='bar red active' data-percent='85' data-skill='CSS3'></div>";

    var isMenuExist = document.getElementsByClassName('menu-box').length > 0 ? true : false;

    var app = document.getElementById('app');
    var body = document.getElementsByTagName('body')[0];
    var temp = document.createElement('div');
    temp.id = 'loadingBox';
    if (status) {
        // body.style.overflow='hidden';
        temp.innerHTML = html;
        app.appendChild(temp);
        if (isMenuExist) {
            var bar = document.getElementsByClassName('bar');
            for (var i = 0; i < bar.length; i++) {
                bar[i].style.bottom = '55px';
            }
        }

    } else {
        var target = document.getElementById('loadingBox');
        // body.style.overflow='auto';
        if (target) {
            app.removeChild(target);
        }

    }
}


// WEBPACK FOOTER //
// ./src/common/functions.js